import React, { useState, useEffect } from 'react';

const AddBirlikModal = ({ show, onClose, onSave, isEditMode, birlikToEdit, saving = false }) => {
  const [formData, setFormData] = useState({ name: '', description: '' });

  useEffect(() => {
    if (isEditMode && birlikToEdit) {
      setFormData({
        name: birlikToEdit.name || '',
        description: birlikToEdit.description || '',
        id: birlikToEdit.id
      });
    } else {
      setFormData({ name: '', description: '' });
    }
  }, [isEditMode, birlikToEdit, show]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (!formData.name.trim()) {
      alert('Birlik nomi kiritilishi shart!');
      return;
    }

    const birlik = isEditMode ? { ...formData, id: birlikToEdit.id } : { ...formData };
    onSave(birlik);
    // Close the modal after successful submission
    onClose();
  };

  if (!show) return null;

  return (
    <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{isEditMode ? "Tahrirlash" : "Qo'shish"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <label className="form-label">Birlik nomi*</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
              Bekor qilish
            </button>
            <button type="button" className="btn btn-success" onClick={handleSave} disabled={saving}>
              {saving ? "Saqlanmoqda..." : (isEditMode ? "Saqlash" : "Qo'shish")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBirlikModal; 